/* eslint-disable no-loop-func */
import Chip from "@mui/material/Chip";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
// import { Empty } from "antd";
// import axios from "axios";
import Portal from "./Portal";
// import ActionButton from "./ActionButton";
import ERPUtils from "./Utils";
import ApiGateway from "./ApiGateway";
import { toast } from "react-toastify";
import { Button, IconButton } from "@mui/material";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import UploadSharpIcon from "@mui/icons-material/UploadSharp";
import DownloadSharpIcon from "@mui/icons-material/DownloadSharp";
import TaskAltSharpIcon from "@mui/icons-material/TaskAltSharp";
import RotateLeftSharpIcon from "@mui/icons-material/RotateLeftSharp";
import RotateRightSharpIcon from "@mui/icons-material/RotateRightSharp";
import ZoomOutSharpIcon from "@mui/icons-material/ZoomOutSharp";
import ZoomInSharpIcon from "@mui/icons-material/ZoomInSharp";
import EmptyIcon from "../images/EmptyIcon.png"



// import AppContext from "./AppContext";

const SCREEN_WIDTH = window.innerWidth;
const SCREEN_HEIGHT = window.innerHeight;

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

export default function UploadViewPopup(props) {
  const [previewFile, setPreviewFile] = useState([]);
  const [previewIndex, setPreviewIndex] = useState(0);
  const [IsDocument, setIsDocument] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const [fileTypes, setFileTypes] = useState([]);
  const [imageRotateAngle, setImageRotateAngle] = useState(0);
  const [imgScale, setImageScale] = useState(1);
  const styles = {
    mainStyle: {
      position: "fixed",
      width: "100%",
      height: "100%",
      backgroundColor: "#00000085",
      top: "0",
      left: "0",
      zIndex:"2000",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  };

  const closePopup = () => {
    props.closePopup();
  };

  const submitFiles = () => {
    props?.submitData();
  };

  const updateAllStates = (array, extensionArray, finalDataArray) => {
    setFileNames(array);
    setFileTypes(extensionArray);
    setPreviewFile(finalDataArray.length !== 0 ? finalDataArray : []);
    setPreviewIndex(0);
    setIsDocument(finalDataArray[0]?.extension === "pdf");
    document.getElementById("upload-component-close-btn")?.focus();
  };

  useEffect( () => {
    async function fetchData() {
    const datas = props?.data || [];
    const finalDataArray = [];
    const array = [];
    const extensionArray = [];
    // let previewImages = [];
    const previewUrlsList = [];
    const previewListLenght = [];
    for (let index = 0; index < datas.length; index++) {
      // checking if the item is either a file obj or a dto object
      if (typeof datas[index] === "object") {
        // if it is a file object
        if (!ERPUtils.isNullorWhiteSpace(datas[index]?.file)) {
          array.push(datas[index]?.name);
          const spittedArray = datas[index]?.name?.split(".") || [];
          extensionArray.push(spittedArray[spittedArray.length - 1] || "");
          finalDataArray.push({
            url: URL.createObjectURL(datas[index].file),
            fileName: datas[index]?.name,
            extension: datas[index]?.extension || "",
          });
          previewListLenght.push("0");
          // if the file is already existing file
        } else if (ERPUtils.isNullorWhiteSpace(datas[index]?.preSignedUrl)
          && !ERPUtils.isNullorWhiteSpace(datas[index]?.tempPath)) {
          const obj = {
            originalFileName: "",
            uniqueFileName: "",
            tempPath: "",
            actualPath: "",
            preSignedUrl: "",
            processCode: props?.processKey,
          };
          obj.originalFileName = datas[index]?.originalFileName;
          obj.tempPath = datas[index]?.tempPath;
          previewUrlsList.push(obj);
          // if the file is new one and to be dispalyed from local
        } else if (ERPUtils.isNullorWhiteSpace(datas[index]?.preSignedUrl)
          && !ERPUtils.isNullorWhiteSpace(datas[index]?.actualPath)) {
          const obj = {
            originalFileName: "",
            uniqueFileName: "",
            tempPath: "",
            actualPath: "",
            preSignedUrl: "",
            processCode: props?.processKey,
          };
          obj.originalFileName = datas[index]?.originalFileName;
          obj.actualPath = datas[index]?.actualPath;
          previewUrlsList.push(obj);
          // if the file is new one and to be dispalyed from local
        } else {
          array.push(datas[index]?.originalFileName);
          const spittedArray = datas[index]?.originalFileName?.split(".") || [];
          extensionArray.push(spittedArray[spittedArray.length - 1] || "");
          finalDataArray.push({
            url: URL.createObjectURL(datas[index]?.preSignedUrl),
            fileName: datas[index]?.originalFileName,
            extension: spittedArray[spittedArray.length - 1] || "",
          });
          previewListLenght.push("0");
        }
      }
    }
    // here the files with actual path is send and presignedUrl is taken
    // need to be validated here
    if (previewUrlsList.length !== 0) {
      ERPUtils.loading(props.tabId, true);
      await ApiGateway.post("fileUploadDownLoad/download/presigned", previewUrlsList, async (response) => {
        const responseObj = !ERPUtils.isUndefinedOrNull(response?.data)? response.data : []
        if (!ERPUtils.isNullorWhiteSpace(responseObj)) {
          for (let index = 0; index < responseObj.length; index++) {
            const spittedArray = responseObj[index]?.originalFileName?.split(".") || [];
            extensionArray.push(spittedArray[spittedArray.length - 1] || "");
            finalDataArray.push({
              url: responseObj[index]?.preSignedUrl,
              fileName: responseObj[index]?.originalFileName,
              extension: spittedArray[spittedArray.length - 1] || "",
            });
            previewListLenght.push("0");
            array.push(responseObj[index]?.originalFileName);
          }
          if (previewListLenght.length === datas?.length) {
            await updateAllStates(array, extensionArray, finalDataArray);
          }
        } else {
          toast.warn({ Type: "danger", Text: "Sorry, Uploading Failed" });
        }
        ERPUtils.loading(props.tabId, false);
      },);
    } else if (previewListLenght.length === datas?.length) {
      await updateAllStates(array, extensionArray, finalDataArray);
      await ERPUtils.loading(props.tabId, false);
    }
  }
  fetchData();
  }, [props,props.data]);

  const onChipSelected = (event, id) => {
    event.preventDefault();
    for (let index = 0; index < previewFile.length; index++) {
      if (index === id) {
        // setIsDocument(previewFile[index].extension === "pdf");
        setPreviewIndex(id);
      }
    }
  };

  const handleDelete = (fileName, id) => {
    if (!props?.isViewOnly) {
      props?.onDelete(fileName, id);
      setPreviewIndex(0);
    }
  };

  const openUploadWindow = () => {
    props?.openUploadWindow();
  };

  // download the active file
  const downloadCurrentFile = () => {
    const link = document.createElement("a");
    link.href = previewFile[previewIndex]?.url;
    link.download = previewFile[previewIndex]?.fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  //  rotate method
  const rotateImage = (side, id) => {
    if (side === "right") {
      const angle = imageRotateAngle + 90;
      document.getElementById("image_container").style.transform = `rotate(${angle}deg)`;
      setImageRotateAngle(angle);
    } else if (side === "left") {
      const angle = imageRotateAngle - 90;
      document.getElementById("image_container").style.transform = `rotate(${angle}deg)`;
      setImageRotateAngle(angle);
    }
    setTimeout(() => {
      document.getElementById(id).focus();
    }, 400);
  };

  const zoomin = () => {
    const myImg = document.getElementById("image_container");
    const newScale = imgScale !== 0 ? imgScale + 0.25 : 1;
    myImg.style.transform = `scale(${newScale})`;
    myImg.style.transition = "transform 0.25s ease";
    setImageScale(newScale);
    setTimeout(() => {
      document.getElementById("upload-component-zoomin-btn").focus();
    }, 400);
    return null;
  };

  const zoomout = () => {
    const myImg = document.getElementById("image_container");
    const newScale = imgScale !== 0 ? imgScale - 0.25 : 1;
    myImg.style.transform = `scale(${newScale})`;
    myImg.style.transition = "transform 0.25s ease";
    setImageScale(newScale);
    setTimeout(() => {
      document.getElementById("upload-component-zoomout-btn").focus();
    }, 400);
    return null;
  };

  return (
    <Portal id="portal-container">
      <div style={styles.mainStyle}>
        <div
          className="uploadPopupMainBox"
          style={{ height: `${SCREEN_HEIGHT - 150}px`, width: "90%" }}
        >
          <div className="d-flex " style={{ width: "100%" }}>
            <div className="fileNameRow-container p-2" style={{ width: SCREEN_WIDTH > 600 ? "95%" : "85%" }}>
              {fileNames.length > 0
                ? (
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexWrap: "nowrap",
                      listStyle: "none",
                      overflow: "auto",
                      boxShadow: "0 0 4px #0002",
                      p: 0.5,
                      m: 0,
                    }}
                    component="ul"
                  >
                    {fileNames.map((el, index) => (
                      <ListItem key={index} className="list-item-upload-chips">
                        <Chip
                          label={<span className="upload-chip-label">{el}</span>}
                          onClick={(e) => onChipSelected(e, index)}
                          onDelete={() => handleDelete(el, index)}
                          deleteIcon={!props?.isViewOnly ? <DeleteIcon /> : null}
                          clickable
                          style={previewIndex === index ? { border: "2px solid #2684ff " } : { border: "" }}
                        />
                      </ListItem>
                    ))}
                    {/* <div className="p-2 d-flex justify-content-end align-items-center"> */}

                    {/* </div> */}
                  </Paper>
                ) : null}
            </div>
            {SCREEN_WIDTH > 600
              ? (
                <div className="fileNameRow-container pe-2 pt-2 pb-2">
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexWrap: "nowrap",
                      listStyle: "none",
                      overflow: "auto",
                      boxShadow: "0 0 4px #0002",
                      p: 0.5,
                      m: 0,
                    }}
                    component="div"
                  >
                    <span className="d-flex justify-content-center">
                     <IconButton
            aria-label="close"
                           color="error"
                            id="upload-component-close-btn"
                           className="me-2"
                           onClick={closePopup}
                           title={ "Close"}
                          >
                          <CloseSharpIcon />
                      </IconButton>

                    </span>
                  </Paper>
                </div>
              )
              : (
                <span className="d-flex justify-content-center">
                  <IconButton
            aria-label="close"
            color="error"
             id="upload-component-close-btn"
            className="me-2"
            onClick={closePopup}
            title={ "Close"}
          >
            <CloseSharpIcon />
          </IconButton>
                </span>
              )}
          </div>
          <div className="p-2" style={{ height: "100%", overflow:"hidden" }}>
            <span className="position-relative upload-chip-label-2" style={{ top: "0px", left: "5px" }}>{previewFile[previewIndex]?.fileName}</span>
            <div className="upload-imagePreview-parent">
              {ERPUtils.isUndefinedOrNull(previewFile[previewIndex] || ERPUtils.isNullorWhiteSpace(previewFile[previewIndex]))
                ? (
                  <div className="upload-component-preview-image">
                   <img src={EmptyIcon} alt="File Empty" >
                    <p>Empty</p>
                   </img></div>
                )
                : previewFile[previewIndex]?.extension === "docx" || previewFile[previewIndex]?.extension === "xlsx" || previewFile[previewIndex]?.extension === "pdf"
                  ? (
                   <div className="upload-component-preview-image">
                    <div	>
                     {previewFile[previewIndex]?.extension === "docx" ? <i className="far fa-file-word" style={{ fontSize: "5rem" }} />	
                        : previewFile[previewIndex]?.extension === "pdf" ? <i className="far fa-file-pdf" style={{ fontSize: "5rem" }} />
                         : <i className="far fa-file-excel" style={{ fontSize: "5rem" }} />
                         }	
                        <div className="mt-2">	
                          <b>	
                            {previewFile[previewIndex]?.fileName}	
                          </b>	
                          <br />	
                          ( Preview not available)	
                        </div>	
                                   </div>
                   </div>
                  )
                  : previewFile[previewIndex]?.extension === "jpg" || previewFile[previewIndex]?.extension === "jpeg" || previewFile[previewIndex]?.extension === "png" || previewFile[previewIndex]?.extension === "svg" ? (
                    <span className="image-container-parent" id="image-drag-container">
                      <img src={previewFile[previewIndex]?.url} draggable id="image_container" alt={previewFile[previewIndex]?.fileName} />
                    </span>
                  )
                    : (
                          <div className="upload-component-preview-image">
                        <div className="mt-2">	
                          <b>	
                            {previewFile[previewIndex]?.fileName}	
                          </b>	
                          <br />	
                          ( Preview not available)	
                        </div>	
                   </div>
                                )}
                      {/* <Empty
                        image={<i className="fas fa-file-alt" style={{ fontSize: "5rem" }} />}
                        imageStyle={{ height: 100 }}
                        description={(
                          <span>
                            <b>
                              {previewFile[previewIndex]?.fileName}
                            </b>
                            <br />
                            ( Preview not available .)
                          </span>
                          )}
                      />
                    )} */}
            </div>
          </div>
          <div className=" d-flex justify-content-between align-items-enter border" style={{ height: "10%" }}>
            <div className="d-flex justify-content-between align-items-center ">
              
                {!props?.isViewOnly && (
              <IconButton
            aria-label="upload"
            sx={{ color: "#000000" }}
            className="m-0"
            onClick={openUploadWindow}
            title="Upload"
          >
            <UploadSharpIcon />
          </IconButton>
                 )}
              <IconButton
            aria-label="Download"
            color="primary"
            className= "mr-2"
          id="upload-component-download-btn"
           onClick={downloadCurrentFile}
            title="download current file"
          >
            <DownloadSharpIcon />
            
          </IconButton>

            </div>
            <div className="d-flex justify-content-between align-items-center">
                           <IconButton
            aria-label="Rotate left"
            sx={{ color: "#000000" }}
            className={ "mr-"}
            id="upload-component-rotateleft-btn"
            onClick={() => rotateImage("left", "upload-component-rotateleft-btn")}
            title={ "Rotate left"}
            >
            <RotateLeftSharpIcon />
          </IconButton>
            {window.innerWidth < 768 ? null : 
            <div>
                           <IconButton
            aria-label="zoomout "
            sx={{ color: "#000000" }}
            className="mr-2 "
           id="upload-component-zoomout-btn"
           onClick={zoomout}
            title="zoom out image"
          >
            <ZoomOutSharpIcon />
          </IconButton>
             
              <IconButton
            aria-label="zoom in"
            sx={{ color: "#000000" }}
              className="mr-1"
                id="upload-component-zoomin-btn"
                onClick={zoomin}
                title="zoom in image"
          >
            <ZoomInSharpIcon />
          </IconButton>
          </div>
            }
              
              <IconButton
            aria-label="Rotate right"
            sx={{ color: "#000000" }}
            className="mr-1"
                id="upload-component-rotateright-btn"
                onClick={() => rotateImage("right", "upload-component-rotateright-btn")}
            title={"Rotate right"}
          >
            <RotateRightSharpIcon />
          </IconButton>
            </div>
            <div className="d-flex align-items-center">
              {props?.isSubmitButton
                ? (
                  <Button
            variant="contained"
            color="success"
            aria-label="Submit"
            onClick={submitFiles}
            className="mr-2"
            startIcon={<TaskAltSharpIcon />}
            style={{ fontFamily: "'Open Sans', sans-serif" }}
            onDoubleClick={() => null}
            title="Submit"
          >
            Submit
          </Button>
                ) : null}
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
}
